<template>
  <div class="q-page">
    <div class="container py-5">
      <div class="q-complete-wrap">
        <div class="q-complete-icon">
          <i class="bi bi-check-lg"></i>
        </div>
        <h1 class="q-complete-title">¡Pedido completado!</h1>
        <p class="q-complete-sub">Tu pedido ha sido recibido. Nos pondremos en contacto a la brevedad.</p>
        <router-link :to="{ name: 'Store' }" class="btn btn-primary">
          <i class="bi bi-arrow-left me-2"></i>Ir a la tienda
        </router-link>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters, mapMutations } from "vuex";

export default {
  name: "Complete-Order",
  computed: {
    ...mapState("ecommerce", ["basket"]),
    ...mapGetters({ basketSum: "ecommerce/basketSum" }),
  },
  methods: {
    ...mapMutations({
      clearBasketMutation: "ecommerce/CLEAR_BASKET",
      clearOrderMutation: "ecommerce/CLEAR_ORDER",
    }),
  },
  created() {
    this.clearBasketMutation();
  },
  beforeDestroy() {
    this.clearOrderMutation();
  },
};
</script>

<style scoped>
.q-complete-wrap {
  max-width: 480px;
  margin: 0 auto;
  text-align: center;
  padding: 60px 0;
}
.q-complete-icon {
  width: 80px; height: 80px;
  border-radius: 50%;
  background: rgba(0, 112, 243, 0.15);
  border: 2px solid var(--primary-color);
  display: flex; align-items: center; justify-content: center;
  margin: 0 auto 28px;
  font-size: 2.5rem;
  color: var(--primary-color);
}
.q-complete-title {
  font-family: var(--q-font-display);
  font-size: 1.75rem; font-weight: 800;
  letter-spacing: 0.04em;
  color: var(--q-text);
  margin-bottom: 12px;
}
.q-complete-sub {
  font-size: 14px;
  color: var(--q-text-muted);
  margin-bottom: 32px;
  line-height: 1.6;
}
</style>
